import {Card} from 'components/common/Card'
import {Image} from 'components/common/Image'
import {Button} from 'components/system/Button'
import {lowerCase} from 'lodash'
import {useCurrency} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'
import {Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {TourDetailsButton} from './TourDetailsButton'
import {getProductDurationFrom} from './utils/getProductDurationFrom'
import {getProductPricingFrom} from './utils/getProductPricingFrom'

type Props = {
  product: Ventrata.Product
  onCheckAvailability: (productId: string) => void
  onShowDetails: (productId: string) => void
}

export const TourCard = ({product, onCheckAvailability, onShowDetails}: Props) => {
  const currency = useCurrency()

  const checkAvailability = useCallback(() => {
    onCheckAvailability(product.id)
  }, [product.id, onCheckAvailability])

  const showDetails = useCallback(() => {
    onShowDetails(product.id)
  }, [product.id, onShowDetails])

  const productPricingMapFrom = getProductPricingFrom(product, currency)
  const productDuartionFrom = getProductDurationFrom(product)
  const firstOption = product.options[0]

  const isProductWithIncorrectCurrency = firstOption.units.some((unit) => productPricingMapFrom[unit.id] === null)

  if (isProductWithIncorrectCurrency) {
    return null
  }

  return (
    <div>
      <Card
        className="bg-gray-4 rounded-lg"
        image={<Image src={product.coverImageUrl} title={product.title} />}
        header={
          <div className="flex flex-col">
            <div className="font-bold text-lg">{product.title}</div>
          </div>
        }
        main={
          <div className="flex flex-col">
            {product.subtitle && (
              <div className="text-text-secondary" dangerouslySetInnerHTML={{__html: product.subtitle}} />
            )}
            <div className="flex flex-col gap-4 py-4">
              <div className="grid grid-cols-[150px_1fr] gap-y-2">
                <div>Cost from:</div>
                <div className="font-medium text-end">
                  {firstOption.units
                    .map((unit) => `${formatMoney(productPricingMapFrom[unit.id], currency)}/${lowerCase(unit.title)}`)
                    .join(', ')}
                </div>
                <div>Duration from:</div>
                <div className="font-medium text-end">{productDuartionFrom}</div>
              </div>
            </div>

            <div className="flex flex-col d:flex-row gap-3 d:gap-6 items-center">
              <Button.Secondary.Black onClick={checkAvailability} autoExpanded className="!h-[40px]">
                Check Availability
              </Button.Secondary.Black>
              <TourDetailsButton onClick={showDetails} />
            </div>
          </div>
        }
      />
    </div>
  )
}
